/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface OrderPaymentForReport
 */
export interface OrderPaymentForReportOptional {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentToRefundCents?: number;
}

export interface OrderPaymentForReport extends OrderPaymentForReportOptional {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentToRefundCents?: number;
}

export interface OrderPaymentForReportTrackedI {
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentForReport
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentForReport
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
}

transformDatesMap.set(
  "OrderPaymentForReport",
  function (model: OrderPaymentForReport) {
    if (typeof model.paymentCapturableDate == "string")
      model.paymentCapturableDate = new Date(model.paymentCapturableDate);
  },
);

export type OrderPaymentForReportMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var OrderPaymentForReportMeta: OrderPaymentForReportMetaI =
  {} as OrderPaymentForReportMetaI;
OrderPaymentForReportMeta = typeMeta("OrderPaymentForReport", {
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = OrderPaymentForReportMeta;

registerMeta(() => {});

export class OrderPaymentForReportTracked implements OrderPaymentForReportTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  constructor(config?: OrderPaymentForReportOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: OrderPaymentForReportOptional,
    options?: AssignOptions,
  ): OrderPaymentForReportTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderPaymentForReportTrackedI {
    const cloned = {} as OrderPaymentForReportTrackedI;
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderPaymentForReportTrackedI {
    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    return this;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentServiceChangeCents,
      OrderPaymentForReportMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentCapturableCents,
      OrderPaymentForReportMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentCapturableDate,
      OrderPaymentForReportMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentPaidCents,
      OrderPaymentForReportMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentTotalCents,
      OrderPaymentForReportMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentRefundedCents,
      OrderPaymentForReportMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentForReportMeta.paymentToRefundCents,
      OrderPaymentForReportMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
